import { Routes, RouterModule, PreloadAllModules } from "@angular/router";
import {  NgModule } from "@angular/core";
import { PagesComponent } from "./pages/pages.component";
import { PageNotMatchComponent } from "./pages/page-not-match/page-not-match.component";

export const routes: Routes = [
  {
    path: "",
    component: PagesComponent,
    children: [
      {
        path: "active-session",
        loadChildren: () =>
          import("./pages/active-session/active-session.module").then(
            (m) => m.ActiveSessionModule
          ),
        data: { breadcrumb: "active-session" },
      },
      {
        path: "tax/relationship",
        loadChildren: () =>
          import("./pages/taxs-details/taxs-details.module").then(
            (m) => m.TaxDetailsModule
          ),
        data: { breadcrumb: "tax/relationship" },
      },

      {
        path: "operational-dashboard",
        loadChildren: () =>
          import(
            "./pages/operational-dashboard/operational-dashboard.module"
          ).then((m) => m.OperationalDashboardModule),
        data: { breadcrumb: "operational-dashboard" },
      },
      {
        path: "oig",
        loadChildren: () =>
          import(
            "./pages/oig/oig.module"
          ).then((m) => m.OigModule),
        data: { breadcrumb: "oig" },
      },

      {
        path: "manage-service",
        loadChildren: () =>
          import("./pages/manage-service/manage-service.module").then(
            (m) => m.ManageServiceModule
          ),
        data: { breadcrumb: "manage-service" },
      },

      {
        path: "Visits",
        loadChildren: () =>
          import("./pages/evvtimesheet/evvtimesheet.module").then(
            (m) => m.EvvtimesheetModule
          ),
        
      },
      {
        path: "schedule",
        loadChildren: () =>
          import("./pages/schedule/schedule.module").then(
            (m) => m.ScheduleModule
          ),
        data: { breadcrumb: "manage-service" },
      },
      {
        path: "payroll",
        loadChildren: () =>
          import("./pages/payroll/payroll.module").then(
            (m) => m.PayrollModule),
        // data: { breadcrumb: "payroll" },
      },
      {
        path: "agency",
        loadChildren: () =>
          import("./pages/agency/agency.module").then((m) => m.AgencyModule),
        data: { breadcrumb: "agency" },
      },
      {
        path: "agency-report",
        loadChildren: () =>
          import("./pages/agencyreport/agencyreport.module").then(
            (m) => m.AgencyreportModule
          ),
        data: { breadcrumb: "agencyreport" },
      },
      {
        path: "Client",
        loadChildren: () =>
          import("./pages/client-parent/client-parent.module").then(
            (m) => m.ClientParentModule
          ),
        data: { breadcrumb: "Client" },
      },
      {
        path: "Employee",
        loadChildren: () =>
          import("./pages/employee/employee.module").then(
            (m) => m.EmployeeModule
          ),
        data: { breadcrumb: "employee" },
      },
      {
        path: "case-manager",
        loadChildren: () =>
          import("./pages/case-manager/case-manager.module").then(
            (m) => m.CaseManagerModule
          ),
        data: { breadcrumb: "case-manager" },
      },
      {
        path: "clearing-house",
        loadChildren: () =>
          import("./pages/clearing-house/clearing-house.module").then(
            (m) => m.ClearingHouseModule
          ),
        data: { breadcrumb: "clearing-house" },
      },
      {
        path: "care-coordinator",
        loadChildren: () =>
          import("./pages/care-coordinator/care-coordinator.module").then(
            (m) => m.CareCoordinatorModule
          ),
        data: { breadcrumb: "care-coordinator" },
      },

      {
        path: "list",
        loadChildren: () =>
          import("./pages/list/list.module").then((m) => m.ListModule),
        data: { breadcrumb: "list" },
      },

      {
        path: "lov",
        loadChildren: () =>
          import("./pages/lov/lov.module").then((m) => m.LovModule),
        data: { breadcrumb: "lov" },
      },
      {
        path: "Payer",
        loadChildren: () =>
          import("./pages/payer/payer.module").then((m) => m.PayerModule),
        data: { breadcrumb: "Payer" },
      },
      {
        path: "location",
        loadChildren: () =>
          import("./pages/location/location.module").then(
            (m) => m.LocationModule
          ),
        data: { breadcrumb: "location" },
      },

      {
        path: "supportplanner",
        loadChildren: () =>
          import("./pages/supportplanner/supportplanner.module").then(
            (m) => m.SupportplannerModule
          ),
        data: { breadcrumb: "supportplanner" },
      },
       {
        path: "cfssagency",
        loadChildren: () =>
          import("./pages/cfss-agency/cfss-agency.module").then(
            (m) => m.CFSSAgencyModule
          ),
        data: { breadcrumb: "cfssagency" },
      },
      {
        path: "vendor",
        loadChildren: () =>
          import("./pages/vendor/vendor.module").then(
            (m) => m.vendorModule
          ),
        data: { breadcrumb: "vendor" },
      },

      {
        path: "user",
        loadChildren: () =>
          import("./pages/users/users.module").then((m) => m.UsersModule),
        data: { breadcrumb: "user" },
      },
     
      {
        path: "agreementTemplate",
        loadChildren: () =>
          import("./pages/agreement-template/agreement-template.module").then(
            (m) => m.AgreementTemplateModule
          ),
        data: { breadcrumb: "template" },
      },
      {
        path: "roles",
        loadChildren: () =>
          import("./pages/roles/roles.module").then((m) => m.RolesModule),
        data: { breadcrumb: "roles" },
      },
      {
        path: "budgetimport",
        loadChildren: () =>
          import("./pages/budgetimport/budgetimport.module").then((m) => m.BudgetimportModule),
        data: { breadcrumb: "budgetimport" },
      },
      {
        path: "report",
        loadChildren: () =>
          import("./pages/reports/reports.module").then((m) => m.ReportsModule),
        data: { breadcrumb: "report" },
      },
     
      {
        path: "menus",
        loadChildren: () =>
          import("./pages/menus-new/menus-new.module").then(
            (m) => m.MenuNewModule
          ),
        data: { breadcrumb: "menus" },
      },
      {
        path: "employee-agreementlist",
        loadChildren: () =>
          import(
            "./pages/employee-agreementlist/employee-agreementlist.module"
          ).then((m) => m.EmployeeAgreementlistModule),
        data: { breadcrumb: "employee-agreementlist" },
      },
      {
        path: "client-onboarding-list",
        loadChildren: () =>
          import(
            "./pages/client-onboardinglist/client-onboardinglist.module"
          ).then((m) => m.clientOnboardingListModule),
        data: { breadcrumb: "client-onboarding-list" },
      },

      {
        path: "purchase-list",
        loadChildren: () =>
          import(
            "./pages/purchase-request/purchase-request.module"
          ).then((m) => m.PurchaseRequestModule),
        data: { breadcrumb: "purchase-list" },
      },
     

      {
        path: "timesheets",
        loadChildren: () =>
          import("./pages/timesheet/timesheet.module").then(
            (m) => m.TimesheetModule
          ),
        data: { breadcrumb: "timesheet" },
      },
      // {
      //   path: "timesheet-Verification",
      //   loadChildren: () =>
      //     import("./pages/timesheet-verification/timesheet-verification.module").then(
      //       (m) => m.TimesheetVerificationModule
      //     ),
      //   data: { breadcrumb: "timesheet-Verification" },
      // },

      {
        path: "transactions",
        loadChildren: () =>
          import("./pages/transaction-menu/transaction-menu.module").then(
            (m) => m.TransactionMenuModule
          ),
        data: { breadcrumb: "timesheet" },
      },
      
      {
        path: "payor-mapping",
        loadChildren: () =>
          import("./pages/group-payor-mapping/group-payor-mapping.module").then(
            (m) => m.GroupPayorMappingModule
          ),
        data: { breadcrumb: "payormapping" },
      },
      {
        path: "claims",
        loadChildren: () =>
          import("./pages/claims/claims.module").then(
            (m) => m.ClaimsModule
          ),
        data: { breadcrumb: "claims" },
      },
      // {
      //   path: "purchase-Verification",
      //   loadChildren: () =>
      //     import("./pages/purchase-verification/purchase-verification.module").then(
      //       (m) => m.PurchaseVerificationModule
      //     ),
       
      // },
      // {
      //   path: "transaction-Verification",
      //   loadChildren: () =>
      //     import("./pages/transaction-verification/transaction-verification.module").then(
      //       (m) => m.TransactionVerificationModule
      //     ),
       
      // },
      {
        path: "importPayment",
        loadChildren: () =>
          import("./pages/import-payment/import-payment.module").then(
            (m) => m.ImportPaymentModule
          ),
        data: { breadcrumb: "claims" },
      },
      {
        path: "transaction-logs",
        loadChildren: () =>
          import("./pages/transaction-logs/transaction-logs.module").then(
            (m) => m.TransactionLogsModule),
       
      },
      {
        path: "caregiver-logs",
        loadChildren: () =>
          import("./pages/caregiver-logs/caregiver-logs.module").then(
            (m) => m.CaregiverLogsModule),
       
      },
      {
        path: "handbook",
        loadChildren: () =>
          import("./pages/handbook/handbook.module").then((m) => m.HandBookModule),
        data: { breadcrumb: "report" },
      },
      {
        path: "icd10",
        loadChildren: () =>
          import("./pages/icd10/icd10.module").then((m) => m.ICD10Module),
      },

      {
        path: "dynamicformtemplate",
        loadChildren: () =>
          import("./pages/dynamicformtemplate/dynamicformtemplate.module").then((m) => m.DynamicFormTemplateModule),
      },
      {
        path: "verifications",
        loadChildren: () =>
          import("./pages/verifications/verifications.module").then(
            (m) => m.VerificationsModule
          ),
        data: { breadcrumb: "verifications" },
      },
          {
        path: "app-maintenance",
        loadChildren: () =>
          import("./pages/app-maintenance/app-maintenance.module").then(
            (m) => m.AppMaintenanceModule
          ),
        data: { breadcrumb: "/app-maintenance"}
        },
        {
          path: "eligibility",
          loadChildren: () =>
            import("./pages/eligibility270/eligibility270.module").then(
              (m) => m.Eligibility270Module
            ),
          
          data: { breadcrumb: "eligibility" },
        },
       {
          path:"eligibility-logs",
          loadChildren:()=>
          import("./pages/eligibility-logs/eligibility-logs.module").then((m)=>m.EligibilityLogsModule),
         
           data: { breadcrumb: "eligibility-logs" },
        },
      {
        path: 'eligibility-report',
        loadChildren: () => import('./pages/eligibility-report/eligibility-report.module').then(m => m.EligibilityReportModule)
      },
      {
        path: 'eligibility-details',
        loadChildren: () => import('./pages/eligibility-details/eligibility-details.module').then(m => m.EligibilityDetailsModule)
      },
      {
        path: 'eligibility-difference-report',
        loadChildren: () => import('./pages/eligibility-difference-report/eligibility-difference-report.module').then(m => m.EligibilityDifferenceReportModule)
      },

    ],
  },

  {
    path: "onboarding/client/:agencycode",
    loadChildren: () =>
      import("./pages/onboarding/onboarding.module").then(
        (m) => m.OnboardingModule
      ),
  },
  {
    path: "onboarding/employee/:agencycode",
    loadChildren: () =>
      import("./pages/onboarding/onboarding.module").then(
        (m) => m.OnboardingModule
      ),
  },
  {
    path: "forgot-password",
    loadChildren: () =>
      import("./pages/forgotpassword/forgotpassword.module").then(
        (m) => m.ForgotpasswordModule
      ),
  },
  {
    path: "reset-password",
    loadChildren: () =>
      import("./pages/resetpassword/resetpassword.module").then(
        (m) => m.ResetpasswordModule
      ),
  },
  {
    path: "login",
    loadChildren: () =>
      import("./pages/login/login.module").then((m) => m.LoginModule),
  },
  {
    path: "password",
    loadChildren: () =>
      import("./pages/password/password.module").then((m) => m.PasswordModule),
  },
  {
    path: "register",
    loadChildren: () =>
      import("./pages/register/register.module").then((m) => m.RegisterModule),
  },
 
  { path: '**', component: PageNotMatchComponent }
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
function appRoutes(
  appRoutes: any,
  arg1: { preloadingStrategy: typeof PreloadAllModules }
) {
  throw new Error("Function not implemented.");
}
